import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'
import { Flex, Title, Text, Anchor } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreUser, type CoreUserAddress } from '@flecto/types'
import { CardList, Icon, TextAddress } from '@flecto/ui'

import styles from './styles.module.css'

type BillingDetailsProps = {
  userData?: CoreUser
  addressData?: CoreUserAddress
}

export function BillingDetails({ userData, addressData }: BillingDetailsProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_billing' })

  const rows = [
    {
      label: t('label_name'),
      value: userData?.business_name ?? '-',
    },
    {
      label: t('label_email'),
      value: userData?.public_email ?? '-',
    },
    {
      label: t('label_vat_number'),
      value: userData?.vat_number ?? '-',
    },
    {
      label: t('label_address'),
    },
  ]

  return (
    <CardList w='100%' h='100%'>
      <Title order={5} mb='md' mt='lg' px='lg'>
        {t('title')}
      </Title>
      {rows.map((row) => (
        <CardList.Item key={row?.label} className={styles.cardListItem}>
          <CardList.ItemLabel className={styles.cardListItemLabel}>
            {row.label ?? ''}
          </CardList.ItemLabel>
          <CardList.ItemValue className={styles.cardListItemValue}>
            {row.label === t('label_address') ? (
              addressData ? (
                <TextAddress
                  address={addressData}
                  withIcon={false}
                  className={styles.address}
                />
              ) : (
                <Text color='gray.9'>{'-'}</Text>
              )
            ) : (
              <Text color='gray.9'>{row.value ?? ''}</Text>
            )}
          </CardList.ItemValue>
        </CardList.Item>
      ))}
      <Flex
        mt='md'
        style={{
          borderTop: '1px solid var(--mantine-color-gray-2)',
        }}
        w='100%'
        py='md'
      >
        <Flex px='lg' gap='xs' align='center' wrap='wrap'>
          <Icon icon={faCircleInfo} color='gray.7' mr='xs' />
          <Text c='gray.7'>{t('info_text')}</Text>
          <Anchor
            c='gray.7'
            fw={500}
            href='/profile/business'
            style={{ textDecoration: 'underline' }}
          >
            {t('info_anchor')}
          </Anchor>
        </Flex>
      </Flex>
    </CardList>
  )
}
